import React, { useState, useEffect } from 'react'
import Dialog from '@components/ui/DialogNew/Dialog'
import { ZinButton } from '@tnl/zin-react'
import { IDLE_TIMEOUT_MODAL_TITLE, IDLE_TIMEOUT_MODAL_MESSAGE, IDLE_TIMEOUT_STAY_SIGNED_IN, IDLE_TIMEOUT_SIGN_OUT } from '@constants'
import './IdleTimeoutModal.scss'

interface IdleTimeoutModalProps {
  isOpen: boolean
  onStaySignedIn: () => void
  onSignOut: () => void
  countdownSeconds: number
}

export const IdleTimeoutModal: React.FC<IdleTimeoutModalProps> = ({ isOpen, onStaySignedIn, onSignOut, countdownSeconds }) => {
  const [timeLeft, setTimeLeft] = useState(countdownSeconds)

  useEffect(() => {
    if (!isOpen) {
      setTimeLeft(countdownSeconds)
      return
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev <= 1 ? 0 : prev - 1
        if (newTime === 0) {
          clearInterval(timer)
          onSignOut()
        }
        return newTime
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [isOpen, countdownSeconds, onSignOut])

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  const handleStaySignedIn = () => {
    onStaySignedIn()
  }

  const handleSignOut = () => {
    onSignOut()
  }

  return (
    <Dialog
      appendTo={document.getElementById('theme-root')?.children[0] as HTMLElement}
      widthAuto={true}
      visible={isOpen}
      onClose={handleStaySignedIn}
      modal={true}
      title={IDLE_TIMEOUT_MODAL_TITLE}>
      <div className="idle-timeout-modal">
        <h2
          className="idle-timeout-modal__title title-2 text-center"
          style={{ color: 'var(--zin-support-error, #c00)' }}>
          {formatTime(timeLeft)}
        </h2>

        <div className="idle-timeout-modal__body text-center">
          <p className="body-2">{IDLE_TIMEOUT_MODAL_MESSAGE}</p>
        </div>

        <div className="idle-timeout-modal__actions">
          <ZinButton
            variant="secondary"
            onClick={handleSignOut}
            className="idle-timeout-modal__action-button"
            size="medium">
            {IDLE_TIMEOUT_SIGN_OUT}
          </ZinButton>
          <ZinButton
            variant="primary"
            onClick={handleStaySignedIn}
            className="idle-timeout-modal__action-button"
            size="medium">
            {IDLE_TIMEOUT_STAY_SIGNED_IN}
          </ZinButton>
        </div>
      </div>
    </Dialog>
  )
}
